import React from 'react';
import { platformUrl } from '../utils/socialPlatforms';
import PlatformIcon from './PlatformIcon';

// The icon comes from PlatformIcon rather than a local <img> so that
// every row in this list is drawn by one component. The payment block
// sorts together now (see sortEntriesForDisplay), which put a tiled
// payment icon directly beside an untiled one -- PayPal, Venmo, Cash App,
// Revolut and Wise are payment methods that open a URL, so they render
// through here, and before this they were the only members of that block
// without the tile.
//
// Nothing changes for a social row: PlatformIcon decides tiling from the
// registry's payment `group`, and no social platform is in it. What a
// social row does gain is the 404 fallback -- this file previously
// rendered a bare <img> with no onError, so a platform whose artwork was
// missing showed a broken image. It now falls back to the same glyph the
// payment rows use.

// displayName/subtitle are resolved by the caller (computeSocialDisplay
// in socialPlatforms.js) rather than here -- telling apart two entries
// that share a platform needs the whole list, not just this one entry.
//
// handleClicks receives the whole entry, not just its platform: the
// server credits a tap to a specific socialEntries row by _id, because a
// profile can carry more than one entry on the same platform and
// platform-matching would credit them all to whichever came first.
export default function ListItem({ entry, displayName, subtitle, handleClicks, isPublic, size }) {
  return (
    <React.Fragment>
      <li className='col-12'>
        <a
          type='instagram'
          href={platformUrl(entry.platform, entry.value)}
          target='_blank'
          rel='noopener noreferrer'
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            margin: 'auto',
          }}
          onClick={() => handleClicks(entry)}
        >
          {/* alt kept as it was rather than defaulted to empty, so the
              rendered markup for a social row is unchanged. */}
          <PlatformIcon platform={entry.platform} size={40} alt="social" />
          <div
            style={{
              marginLeft: '16px',
              padding: '0',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <p
              style={{
                margin: '0',
                padding: '0',
                fontSize: size,
              }}
            >
              <b>{displayName}</b>
            </p>

            {subtitle && (
              <p
                style={{
                  margin: '0',
                  padding: '0',
                  fontSize: '12px',
                  color: '#8a8f98',
                }}
              >
                {subtitle}
              </p>
            )}

            <p
              style={{
                margin: '0',
                padding: '0',
                fontSize: '14px',
              }}
            >
              {!isPublic && (
                <span>
                  <span>{entry.clicks || 0}</span> Clicks
                </span>
              )}
            </p>
          </div>
        </a>
      </li>
      <span
        style={{
          borderTop: '1px solid #bdbdbd',
          // height: '1px',
          width: '100%',
          margin: 'auto',
        }}
      ></span>
    </React.Fragment>
  );
}
